export interface ContractTemplateVariable {
    key: string;
    label: string;
}

export interface ContractTemplateVariableProductTypeScope {
    id?: string | null;
    name?: string | null;
}

export interface ContractTemplateVariableCategory {
    label: string;
    type: string;
    variables: ContractTemplateVariable[];
    productTypeScopes?: ContractTemplateVariableProductTypeScope[];
}

export interface ContractTemplateProductTypeContext {
    id?: string | null;
    name?: string | null;
}

const normalizeValue = (value?: string | null): string => (value ?? '').trim().toLowerCase();

const matchesScope = (
    scope: ContractTemplateVariableProductTypeScope,
    productType?: ContractTemplateProductTypeContext
): boolean => {
    if (!productType) {
        return false;
    }

    const scopeId = normalizeValue(scope.id);
    const scopeName = normalizeValue(scope.name);
    const productTypeId = normalizeValue(productType.id);
    const productTypeName = normalizeValue(productType.name);

    if (scopeId && productTypeId && scopeId === productTypeId) {
        return true;
    }

    return Boolean(scopeName && productTypeName && scopeName === productTypeName);
};

export const filterContractTemplateVariableCategories = (
    categories?: ContractTemplateVariableCategory[],
    productType?: ContractTemplateProductTypeContext
): ContractTemplateVariableCategory[] => {
    if (!Array.isArray(categories)) {
        return [];
    }

    return categories.filter((category) => {
        if (!Array.isArray(category.productTypeScopes) || category.productTypeScopes.length === 0) {
            return true;
        }

        return category.productTypeScopes.some((scope) => matchesScope(scope, productType));
    });
};
